import { render, staticRenderFns } from "./ContentEditable.vue?vue&type=template&id=66ab941d&scoped=true&"
import script from "./ContentEditable.vue?vue&type=script&lang=js&"
export * from "./ContentEditable.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditable.vue?vue&type=style&index=0&id=66ab941d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ab941d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
